import services from './services';
import {
	lg,
	cloneDeep,
	util,
	isCorrectVal,
	isDate
} from 'utils';
import {
	GetProvinces,
	GetCitys,
	GetAreas,
	GetAgentList,
	GetParmConfig, //寄送，支付接口
	GetProductClass,
	GetAgentConsigneeList,
	Consignee_Add,
	GetEmployList,
	ConsigneeSetDefault
} from '@api/commonApi.js';
import NProgress from 'nprogress';
import addSendLessonDialog from '../components/addSendLessonDialog/index.vue'
import addSendLessonView from '../components/addSendLessonView/index.vue'
export default {
	mixins: [services],
	components: {
		addSendLessonDialog,
		addSendLessonView
	},
	data() {
		return {
			Session: util.getSessin(),
			SendLessonReasons: [{
				id: 1,
				name: '公司原因影响课程补偿'
			}, {
				id: 2,
				name: '配合园所活动'
			}, {
				id: 3,
				name: '按时续/扩班'
			}, {
				id: 4,
				name: ' 提前续班'
			}, {
				id: 5,
				name: '提前扩班（3个及以上班级）'
			}],
			queryType: [{
				"TypeName": "全部",
				"TypeValue": "-1"
			}, {
				"TypeName": "待审核",
				"TypeValue": "1"
			}, {
				"TypeName": "审核通过",
				"TypeValue": "6"
			}, {
				"TypeName": "审核不通过",
				"TypeValue": "12"
			}],
			loading: false,
			lists: [],
			pageIndex: 1,
			pageSize: 10,
			totalSize: '',
			sels: [], //列表选中列
			pageSizes: [10, 20, 50],
			query: this.getFormData()

		}
	},
	methods: {
		getFormData() {
			return cloneDeep({
				OrderCode: "",
				AgentName: "",
				SchoolName: "",
				SendLessonReason: "",
				OrderStartTime: "",
				OrderEndTime: "",
				OrderStatus: "-1",
				C_Name: ''
			});
		},
		//查看订单
		handleView(index, row) {
			this.$refs.addSendLessonView.show({
				OrderId: row.OrderId,
				title: '查看送课'
			})

		},
		//审核订单
		handleAudit(index, row) {
			this.$refs.addSendLessonView.show({
				OrderId: row.OrderId,
				title: '审核',
				isAudit: true
			})
		},
		// 删除
		handleDel(row) {
			this.$confirm('确认删除吗？', '提示', {}).then(() => {
				this.DelList(row.OrderId)
			})

		},

		//查询
		onQuerySubmit: function () {
			this.pageIndex = 1;
			this.getList();
		}, //查询功能
		handleSizeChange: function (val) {
			this.pageSize = val;
			this.getList()
		},
		onQueryClean: function () {
			this.query = this.getFormData();
			this.getList();
		},

		handleCurrentChange: function (val) {
			this.pageIndex = val;
			this.getList();
		}
	},
	created() {
		this.getList();
	},

}


// WEBPACK FOOTER //
// ./src/pages/SchoolOrder/SendLessonCheck/vm.js